export function parseTime(input) {
  if (!input) return 0;
  const parts = input.split(":").map(Number);

  if (parts.length === 1) {
    // "5" = 5 minutes
    return parts[0] * 60;
  }
  if (parts.length === 2) {
    // "5:30" = 5 min, 30 sec
    return parts[0] * 60 + parts[1];
  }
  if (parts.length === 3) {
    // "1:10:00" = 1 hr, 10 min, 0 sec
    return parts[0] * 3600 + parts[1] * 60 + parts[2];
  }
  return 0;
}


export function formatTime(seconds) {
  if (isNaN(seconds) || seconds < 0) seconds = 0;
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  return h > 0
    ? [h, m, s].map(v => v.toString().padStart(2, "0")).join(":")
    : [m, s].map(v => v.toString().padStart(2, "0")).join(":");
}

export function formatDisplayTime(seconds) {
  const safeSeconds = Math.max(0, Math.floor(Number(seconds) || 0));
  const h = Math.floor(safeSeconds / 3600);
  const m = Math.floor((safeSeconds % 3600) / 60);
  const s = safeSeconds % 60;

  if (h > 0) {
    return `${h}:${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  }

  return `${m}:${s.toString().padStart(2, "0")}`;
}

export function getTimerDisplayLabel({
  mode,
  running,
  currentPhase,
  selectedPreset,
  timerPairs,
  currentStep,
}) {
  if (mode === "stopwatch") {
    return "Stopwatch";
  }

  if (mode === "preset") {
    if (!running) {
      return selectedPreset === "pomodoro"
        ? "Pomodoro"
        : selectedPreset === "deepwork"
        ? "Deepwork"
        : "Preset Timer";
    }

    return currentPhase === "break" ? "Break" : "Focus";
  }

  if (mode === "custom" && timerPairs && timerPairs[currentStep]) {
    return currentPhase === "break"
      ? timerPairs[currentStep].breakLabel || "BREAK"
      : timerPairs[currentStep].timerLabel || "TIMER";
  }

  return "Custom Timer";
}
